module.exports = __WEBPACK_EXTERNAL_MODULE_589__;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 589
// module chunks = 72